import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const useCNIsPremium = () => {
  const [isPremium, setIsPremium] = useState<boolean | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getPlanFeatures = useCallback(async (signal?: AbortSignal) => {
    try {
      if (isLoading || (window as any).cnIsPremium !== undefined) return;

      setIsLoading(true);
      const { data: bundlesData }: any = await axios(
        `/api/v1/user/planFeatures/?serviceName=bundles`,
        { withCredentials: true, signal }
      );

      const { data: widgetsBundleData }: any = await axios(
        `/api/v1/user/planFeatures/?serviceName=widgetsbundle`,
        { withCredentials: true, signal }
      );

      // Comapre plan features and returns the higest plan features

      const {
        collaborators: bundlesCollaborators = 0,
        websites: bundlesWebsites = 0,
        numberOfInstances: bundlesNumberOfInstances = 0,
      } = bundlesData?.data || {};
      const {
        collaborators: widgetsBundleCollaborators = 0,
        websites: widgetsBundleWebsites = 0,
        numberOfInstances: widgetsBundleNumberOfInstances = 0,
      } = widgetsBundleData?.data || {};

      const collaborators =
        bundlesCollaborators > widgetsBundleCollaborators
          ? bundlesCollaborators
          : widgetsBundleCollaborators;

      const websites =
        bundlesWebsites > widgetsBundleWebsites
          ? bundlesWebsites
          : widgetsBundleWebsites;

      const numberOfInstances =
        bundlesNumberOfInstances > widgetsBundleNumberOfInstances
          ? bundlesNumberOfInstances
          : widgetsBundleNumberOfInstances;

      const data: any = {
        websites,
        collaborators,
        numberOfInstances,
      };

      (window as any).cnIsPremium = (data?.numberOfInstances || 1) > 1;
      setIsPremium((window as any).cnIsPremium);
    } catch (error) {
      if (!axios.isCancel(error)) {
        (window as any).cnIsPremium = false;
        setIsPremium(false);
      }
    } finally {
      if (!signal?.aborted) {
        setIsLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    getPlanFeatures(abortController.signal);

    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isPremium;
};
